module.exports = __webpack_public_path__ + "static/myfcph-63b30e161744d3d3722ccca2bd16e687.jpg";